import React, { useCallback } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Grid, Button } from "@mui/material";
import XDateRange from "../extra/XDateRange";
import dayjs from "dayjs";

export default function Form({ title, companies = [], projects = [], cameras = [],
    defaultValues = {}, onSubmit = (data) => { },
    onChange = (column, data) => { },
}) {
    const [selectedCam, setSelectedCam] = React.useState({});
    const [open, setOpen] = React.useState(false)
    const { handleSubmit, control, watch, setValue } = useForm({ defaultValues: defaultValues, mode: "all" })
    React.useEffect(() => {
        onChange("company", watch("company"))
    }, [watch("company")])

    React.useEffect(() => {
        console.log("data", watch("project"))
        onChange("project", watch("project"))
    }, [watch("project")])
    React.useEffect(() => {
        setSelectedCam(cameras.find((camera) => camera.id == watch("camera")) || {});
    }, [watch("camera"), cameras]);
    return (
        <>

            <form onSubmit={handleSubmit(onSubmit)}>

                <Box sx={{ pb: 0 }}>
                    {title && (
                        <Typography level="h4" textAlign="center" mb={3}>
                            {title}
                        </Typography>
                    )}
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box sx={{ width: 1 }}>
                                <RFG name="company" label="Company" control={control} rules={{ required: true }} className="mb-2">
                                    <select>
                                        <option value="">Select Company</option>
                                        {companies.map((company) => <option value={company.id}>{company.company_name}</option>)}
                                    </select>
                                </RFG>
                            </Box>
                            <Box sx={{ width: 1 }}>
                                <RFG name="project" label="Project Name" control={control} rules={{ required: true }} className="mb-2">
                                    <select>
                                        <option value="">Select Project</option>
                                        {projects.map((project) => <option value={project.id}>{project.project_name}</option>)}
                                    </select>
                                </RFG>
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Box sx={{ width: 1 }}>
                                <RFG name="camera" label="Camera Name" control={control} rules={{ required: true }} className="mb-2">
                                    <select>
                                        <option value="">Select Camera</option>
                                        {cameras.map((camera) => <option value={camera.id}>{camera.camera_name}</option>)}
                                    </select>
                                </RFG>
                                {selectedCam?.first_image_time && <Typography sx={{ fontSize: 12, textAlign: 'left' }}>
                                    Images available from:<br />
                                    {dayjs(selectedCam?.first_image_time).format('DD-MMM-YYYY hh:mm:ss')} to {dayjs(selectedCam?.latest_image_time).format('DD-MMM-YYYY hh:mm:ss')}
                                </Typography>}
                            </Box>
                            <Box sx={{ width: 1 }}>
                                <XDateRange onChange={(start, end) => { setValue("date_from", start); setValue("date_to", end) }} />
                            </Box>
                            <Box textAlign="right" >
                                <Button type="submit" className="btn-primary"
                                    style={{ maxWidth: 100 }}>
                                    Save
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            </form>

        </>
    )
}